import { Prompt } from 'features/textGenerator/store/types';
import { ApiPrompt } from 'services/api/wordEmbedding/types';
import { keysToCamel } from 'utils/utils';

export const promptFromApi = (payload: ApiPrompt) => keysToCamel(payload) as Prompt;
